import React from "react";
import { tw } from "twind";
import ShowMore from "react-show-more";
import { useCartStore } from "store/cart";
import { CartQuery } from "lib/api";

const Description = ({ name, description }: Pick<CartQuery['Cart']['items'][number], 'name' | 'description'>) => {
  const { theme} = useCartStore();
  return (
    <div className={tw`flex-grow flex flex-col text-center mb-[8px]`}>
      <h3 className={tw`leading-6 text-black font-bold`}>{name}</h3>
      {description && <div className={tw`text-sm px-[20px] text-${theme}-primary font-extralight flex-grow`}>
          <ShowMore lines={1} anchorClass={tw`font-bold underline`}>
            {description}
          </ShowMore>
      </div>}
    </div>
  )
}

export default Description;
